// The single semantic-version comparator. Firmware and algorithm versions both
// arrive as "v<major>.<minor>.<patch>" (the leading v is optional) and are compared
// component-by-component as numbers: comparing them as strings puts v1.4.30 below
// v1.4.5 and v3.10.0 below v3.5.0, which silently mis-gates every version check
// below. Mirrors versionSortKey in agamotto-organization-lambda-ms utils/versions.ts.
const SEMVER_RE = /^[vV]?(\d+)\.(\d+)\.(\d+)/;

// null for anything that is not a version, so callers can tell "older" from
// "unknown" rather than having the two collapse together
export const parseVersion = (version) => {
  if (typeof version !== "string" && !(version instanceof String)) return null;
  const match = SEMVER_RE.exec(String(version));
  return match ? [Number(match[1]), Number(match[2]), Number(match[3])] : null;
};

// an unparseable version sorts below every real one, the same ordering the fleet
// query gives it server-side
export const compareVersions = (ver1, ver2) => {
  const parsed1 = parseVersion(ver1);
  const parsed2 = parseVersion(ver2);
  if (!parsed1 && !parsed2) return 0;
  if (!parsed1) return -1;
  if (!parsed2) return 1;
  for (let i = 0; i < parsed1.length; i++) {
    if (parsed1[i] !== parsed2[i]) return parsed1[i] > parsed2[i] ? 1 : -1;
  }
  return 0;
};

export const findLatestVersion = (versions) =>
  (versions || []).slice().sort(compareVersions).pop();
